import request from "@/CommonDP/utils/request";
import { viewOfficeUrl, getToken } from "@/CommonDP/utils";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";

// 文档模块接口
export default {
  lockForUpload(identifier, fileName) {
    return request({
      url: '/doc/lockForUpload',
      params: { identifier, fileName }
    });
  },
  getoffice(fileId) {
    const url = viewOfficeUrl(fileId);
    return request.get(url).then((res) => res);
  },
  queryFilesByFileIds(data) {
    return request.post('/doc/queryFilesByFileIds', data);
  },

  queryConvertMode(fileId, fileVersion) {
    return request.get(`/light/file/convertMode?fileId=${fileId}&fileVersion=${fileVersion}`);
  },
  verifyFileIsDelete(fileId, version) {
    return request({
      method: "GET",
      url: `/doc/verifyFileIsDelete/${fileId}`,
      params: {
        version
      }
    });
  },
  queryhiddenFolder(prjId) {
    return request.get(`/doc/prj/hiddenFolder/queryId?prjId=${prjId}`);
  },

  queryEnterpriseIdhiddenFolder(enterpriseId) {
    return request.get(`/enterprise/doc/hiddenFolder/queryId?enterpriseId=${enterpriseId}`);
  },

  queryDwgSpace(fileID, fileVersion) {
    return request.get(`/doc/query-dwg/web-converts-info?fileId=${fileID}&fileVersion=${fileVersion}`).then((res) => res);
  },
  queryModelUrlList(rvtId, rvtVersion) {
    var a = decodeURIComponent(rvtId);
    var rvtIds = encodeURIComponent(a);
    return request.get(`/doc/unzip-file/list-filePath?fileId=${rvtIds}&fileVersion=${rvtVersion}`).then((res) => res);
  },
  queryModelLightFilesFromMLib(rvtId, rvtVersion) {
    const a = decodeURIComponent(rvtId);
    const rvtIds = encodeURIComponent(a);
    return request.get(`/light/file/list?fileId=${rvtIds}&fileVersion=${rvtVersion}`);
  },
  queryDwgList(fileId, rvtVersion) {
    return request.get(`/doc/model/query-model-paper-infos?fileId=${fileId}&fileVersion=${rvtVersion}`).then((res) => res);
  }, // 取消收藏
  deletePersonFavorite(param) {
    return request.post(`/personal/doc/deleteFavorite`, param);
  },
  // 收藏
  addPersonFavorite(data) {
    return request.post(`/personal/doc/addFavorite`, data);
  },
  // 获取收藏
  queryPersonFavorite(pageSize, pageNum, enterpriseId) {
    return request.get(`/personal/doc/queryFavorite?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${enterpriseId}`);
  },
  //  移动到
  moveFile(param) {
    return request.post(`/personal/doc/move`, param);
  },
  //  复制到
  copyFile(param) {
    return request
      .post(`/personal/doc/copy`, param)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  queryRoleList(prjId, enterpriseId) {
    return request.get(`/doc/permission/queryPrjRoleSpecList?prjId=${prjId}&enterpriseId=${enterpriseId}`);
  },
  queryRoleListNew(prjId, enterpriseId) {
    return request.get(`/doc/permission/spec-role-list/new?prjId=${prjId}&enterpriseId=${enterpriseId}`).then((res) => res);
  },
  genShareLink(params) {
    return request
      .post(`/doc/link/genShareLink`, params)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  genShareNewLink(params) {
    return request
      .post(`/doc/link/genShareLink`, params)
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  queryTree(data = {}) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post("/doc/list", data).then((res) => res);
  },
  queryFolderDetail(folderId) {
    return request.get(`/doc/queryFolderPathByFolderId?folderId=${folderId}`).then((res) => res);
  },
  // 个人文档-我的文档 列表
  querypersonalTree(data = {}) {
    return request.post("/personal/doc/list", data).then((res) => res);
  },
  // 分享资料-公共资料 列表
  queryenterpriseTree(data = {}) {
    return request.post("/enterprise/doc/list", data).then((res) => res);
  },
  // 个人文档-回收站
  querypersonalRecycle(enterpriseId) {
    return request.get(`/personal/doc/recycle/list?enterpriseId=${enterpriseId}`).then((res) => res);
  },
  queryRecycle(prjId, name) {
    return request.get(`/doc/recycle/list?prjId=${prjId}&name=${name}`).then((res) => res);
  },
  // 企业文档-回收站
  queryenterpriseRecycle(enterpriseId) {
    return request.get(`/enterprise/doc/recycle/list?enterpriseId=${enterpriseId}`).then((res) => res);
  },
  queryAddFolder(data = {}) {
    return request.post("/doc/newFolder", data).then((res) => res);
  },
  // 个人文档新建文件夹
  querypersonalAddFolder(data = {}) {
    return request.post("/personal/doc/newFolder", data).then((res) => res);
  },
  // 分享资料/公共资料新建文件夹
  queryenterpriseAddFolder(data = {}) {
    return request.post("/enterprise/doc/newFolder", data).then((res) => res);
  },
  queryDeleteFile(data) {
    return request.post("/doc/delete", data).then((res) => res);
  },
  queryRechristen(data = {}) {
    return request.post("/doc/rename", data).then((res) => res);
  },
  renameMyDoc(data = {}) {
    return request.post("/personal/doc/rename", data);
  },
  querySearchFolder(data = {}) {
    return request.post("/doc/query", data).then((res) => res);
  },
  queryBaseProperty(folderID, isFolder, versionID) {
    return request.post(`/doc/queryDetail?id=${folderID}&isFolder=${isFolder}&versionID=${versionID}`).then((res) => res);
  },
  queryLinkDoc(fileID) {
    return request.post("/doc/relevancy/query", fileID).then((res) => res);
  },
  queryVersions(folderID, prjID) {
    return request.get(`/doc/edition/query?folderID=${folderID}&prjID=${prjID}`).then((res) => res);
  },
  fileMerge(data) {
    return request.post("/doc/mergeFile/fullAmount", data).then((res) => res);
  },
  fileMergeAsync(data) {
    return request.post("/doc/mergeFile/fullAmountAsync", data).then((res) => res);
  },
  fileMergeNoPermission(data) {
    return request.post("/doc/noPermission/mergeFile/fullAmount", data).then((res) => res);
  },
  fileMergeNoPermissionAsync(data) {
    return request.post("/doc/noPermission/mergeFile/fullAmountAsync", data).then((res) => res);
  },
  queryMergeResult(asyncKey,prjId ) {
    return request.get('/doc/mergeFile/queryMergeResult', { params: { asyncKey,prjId  } }).then((res) => res);
  },
  isArchiveFile(fileId) {
    return request.get(`/doc/archive/get-file-real/${fileId}`).then((res) => res);
  },
  recycldelete(data = {}) {
    return request.post("/doc/recycle/delete", data).then((res) => res);
  },
  recyclerestore(data = {}) {
    return request.post("/doc/recycle/restore", data).then((res) => res);
  },
  updateLight(prjId, fileId, version) {
    return request.get(`/doc/re-convert/${prjId}/${fileId}?version=${version || 0}`).then((res) => res);
  },
  // 收藏 11
  addFavorite(data) {
    return request.post(`/doc/addFavorite`, data);
  },
  deleteFavorite(data) {
    return request.post(`/doc/deleteFavorite`, data);
  },
  queryFavorite(pageNo, pageSize) {
    return request.get(`/doc/queryFavorite?pageNo=${pageNo}&pageSize=${pageSize}`);
  },
  navbar(isFolder, id) {
    return request.get(`/doc/navbar/${isFolder}/${id}`).then((res) => res);
  },
  navbarEnterpriseDept(isFolder, id) {
    return request.get(`/enterpriseDept/doc/navbar/${isFolder}/${id}`).then((res) => res);
  },
  // 文档移动
  docMove(params) {
    return request.post(`/doc/move`, params);
  },
  // 文档复制
  docCopy(params) {
    return request.post(`/doc/copy`, params);
  },
  // 流程本地上传获取文件夹id
  getFolderIdByOldId(prjId, oldId) {
    return request.get(`/doc/getFolderIdByOldId?prjId=${prjId}&oldId=${oldId}`);
  },
  downloadfolder(params1) {
    return request({
      responseType: "blob",
      url: "/download/folder",
      method: "post",
      data: params1
    });
  },
  // 获取隐藏文件夹id
  docGetFolderId(params) {
    return request.post(`/doc/getFolderId`, params);
  },
  downloadFile(prjId, fileId, version) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
    if (isDef(newUrl)) {
      if (version) {
        return request({
          responseType: "blob",
          url: `${newUrl}/${prjId}/${fileId}?version=${version}&token=${getToken()}`,
          method: "get"
        });
      } else {
        return request({
          responseType: "blob",
          url: `${newUrl}/${prjId}/${fileId}?token=${getToken()}`,
          method: "get"
        });
      }
    }
    if (version) {
      return request({
        responseType: "blob",
        url: `/doc/download/${prjId}/${fileId}?version=${version}&token=${getToken()}`,
        method: "get"
      });
    } else {
      return request({
        responseType: "blob",
        url: `/doc/download/${prjId}/${fileId}?token=${getToken()}`,
        method: "get"
      });
    }
  },
  prjFileLogList(fileId) {
    return request.get(`/log/prjFileLog/list?fileId=${fileId}`);
  },
  // 上传轻量化文件
  pushRevitLightFile(params) {
    return request.post(`/light/pushRevitLightFile`, params);
  },
  // 判断文件或文件夹是否存在
  docCheckNameExist(params) {
    return request.post(`/doc/checkNameExist`, params);
  },
  // 回收站-重命名后还原
  recycleRenameRestore(params) {
    return request.post(`/doc/recycle/rename/restore`, params);
  },
  // 项目文档 文件或文件夹查看批注列表
  queryAnnotationList(params) {
    return request.post(`/drawing-annotation/rightClick/list`, params);
  },
  // 项目文档 文件或文件夹导出批注列表
  exportAnnotationList(params) {
    return request({
      responseType: "blob",
      url: "/drawing-annotation/rightClick/export",
      method: "post",
      data: params
    });
  },
  // 查询文件夹详情
  getFolderDetail(folderId) {
    return request.get(`/doc/folder/detail?folderId=${folderId}`);
  },
  getPrjSpecTreeNodList(prjId, enterpriseId, oldId) {
    return request.get(`/doc/permission/getPrjSpecTreeNodList?prjId=${prjId}&enterpriseId=${enterpriseId}&oldId=${oldId}`);
  }
};
